// @flow

import LoadingModal from './loading';

export default LoadingModal;
